import { useCallback, useReducer, useRef } from 'react'
import { useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'

import effects from 'app/effects/effects'
import { messageAlertError } from 'commons/error'
import {
  UPDATED_MSG,
  COMMENTS_ENTITY_TYPE,
  COMMENTS_CREATOR_TYPE,
} from 'app/constants/messageDetail'

import MessageAlert from 'app/components/MessageAlert'

export const ActionType = {
  SET_COMMENT_LIST: 'SET_COMMENT_LIST',
  SET_IS_LOADING_LIST: 'SET_IS_LOADING_LIST',
  SET_IS_SUBMIT_SUCCESS: 'SET_IS_SUBMIT_SUCCESS',
  SET_IS_SUBMITTING_COMMENT: 'SET_IS_SUBMITTING_COMMENT',
}

const initialState = {
  count: 0,
  comments: [],
  isLoadingList: false,
  isSubmitSuccess: false,
  isSubmiitingComment: false,
}

const reducer = (state, action) => {
  switch (action.type) {
    case ActionType.SET_IS_LOADING_LIST:
      return {
        ...state,
        isLoadingList: action.value,
      }
    case ActionType.SET_COMMENT_LIST:
      return {
        ...state,
        count: action.count,
        isLoadingList: false,
        isSubmitSuccess: false,
        comments: action.comments,
        isSubmiitingComment: false,
      }
    case ActionType.SET_IS_SUBMITTING_COMMENT:
      return {
        ...state,
        isSubmiitingComment: action.value,
      }
    case ActionType.SET_IS_SUBMIT_SUCCESS:
      return {
        ...state,
        isSubmitSuccess: action.value,
      }
    default:
      return state
  }
}

export default function useComments(
  notiId,
  createId,
  onFetchTimelineWithoutLoader = () => {},
) {
  const { formatMessage } = useIntl()
  const commonDispatch = useDispatch()

  const countCommentsRef = useRef(0)
  const [state, dispatch] = useReducer(reducer, initialState)

  const handleAlertError = useCallback(
    (error) => {
      return commonDispatch(
        MessageAlert.showError({
          message: messageAlertError(error, formatMessage),
        }),
      )
    },
    [commonDispatch, formatMessage],
  )

  const fetchNotificationComments = useCallback(async () => {
    await effects.apis
      .getComments(notiId)
      .then(async (response) => {
        countCommentsRef.current = response.comments
        await dispatch({
          type: 'SET_COMMENT_LIST',
          count: response.comments,
          comments: response.data,
        })
      })
      .catch((error) => handleAlertError(error))
  }, [handleAlertError, notiId])

  const handlefetchNotificationComments = useCallback(() => {
    dispatch({
      type: 'SET_IS_LOADING_LIST',
      value: true,
    })
    fetchNotificationComments()
  }, [fetchNotificationComments])

  const reFetchCommentList = useCallback(async () => {
    await fetchNotificationComments()
    await onFetchTimelineWithoutLoader(notiId, UPDATED_MSG, {
      comments: countCommentsRef.current,
    })
  }, [fetchNotificationComments, notiId, onFetchTimelineWithoutLoader])

  const onSubmittedComment = async (value) => {
    dispatch({
      type: 'SET_IS_SUBMITTING_COMMENT',
      value: true,
    })
    await effects.apis
      .addComment(notiId, {
        ...value,
        entityType: COMMENTS_ENTITY_TYPE,
        entityId: notiId,
        parentId: null,
        creatorType: COMMENTS_CREATOR_TYPE,
        creatorId: createId,
      })
      .then(async () => {
        dispatch({
          type: 'SET_IS_SUBMIT_SUCCESS',
          value: true,
        })
        await reFetchCommentList()
      })
      .catch((error) => {
        dispatch({
          type: 'SET_IS_SUBMITTING_COMMENT',
          value: false,
        })
        handleAlertError(error)
      })
  }

  return {
    state,
    reFetchCommentList,
    onSubmittedComment,
    fetchNotificationComments,
    handlefetchNotificationComments,
  }
}
